import * as React from 'react';

export interface IUseTriggeredTooltip {
  triggerProps: {
    onClick: () => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
  opened: boolean;
  triggered: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
  onClickOutside: () => void;
}

export const useTriggeredTooltip = (
  closeTimeout = 2000
): IUseTriggeredTooltip => {
  const [opened, setOpened] = React.useState<boolean>(false);
  const [triggered, setTriggered] = React.useState<boolean>(false);
  const timeout = React.useRef<NodeJS.Timeout | null>(null);

  const resetTooltip = () => {
    setTriggered(false);
    setOpened(false);
    timeout.current && clearTimeout(timeout.current);
  };

  const onClick = () => {
    setOpened(true);
    setTriggered(true);

    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      resetTooltip();
    }, closeTimeout);
  };

  const onMouseEnter = () => {
    setTriggered(false);
    setOpened(true);
    timeout.current && clearTimeout(timeout.current);
  };

  const onMouseLeave = () => {
    resetTooltip();
  };

  const onClickOutside = () => {
    resetTooltip();
  };

  React.useEffect(() => {
    return () => {
      timeout.current && clearTimeout(timeout.current);
    };
  }, []);

  return {
    triggerProps: {
      onClick,
      onMouseEnter,
      onMouseLeave,
    },
    opened,
    triggered,
    setOpened,
    onClickOutside,
  };
};

export interface IUseHoverableTooltip {
  triggerProps: {
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useHoverableTooltip = (): IUseHoverableTooltip => {
  const [opened, setOpened] = React.useState<boolean>(false);

  const onMouseEnter = () => {
    setOpened(true);
  };

  const onMouseLeave = () => {
    setOpened(false);
  };

  return {
    triggerProps: {
      onMouseEnter,
      onMouseLeave,
    },
    opened,
    setOpened,
  };
};
